
import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Button } from "@/components/ui/button";
import { CommentsProvider } from "./comments/CommentsContext";
import { CommentForm } from "./comments/CommentForm";
import { Comment } from "./comments/Comment";
import { ReplyDialog } from "./comments/ReplyDialog";
import { groupComments } from "./comments/utils";
import { ChatMessageList } from "@/components/ui/chat-message-list";

interface PostModalCommentsProps {
  pinId: string;
  comments: any[];
  user: any | null;
  userAuthenticated: boolean;
  onCommentAdded: () => void;
}

export function PostModalComments({
  pinId,
  comments,
  user,
  userAuthenticated,
  onCommentAdded
}: PostModalCommentsProps) {
  const groupedComments = groupComments(comments);

  return (
    <CommentsProvider initialComments={comments} onCommentAdded={onCommentAdded}>
      <div className="mt-6">
        <h3 className="text-lg font-medium mb-4">Comentários ({comments.length})</h3>
        
        {userAuthenticated ? (
          <CommentForm pinId={pinId} user={user} />
        ) : (
          <div className="bg-muted/30 p-4 rounded-lg text-center mb-6">
            <p className="text-sm mb-2">Faça login para adicionar um comentário</p>
            <Button variant="outline" size="sm" asChild>
              <Link to="/auth">Fazer login</Link>
            </Button>
          </div>
        )}
        
        <div className="h-[350px] md:h-[400px]">
          <ChatMessageList className="pb-2">
            {Object.values(groupedComments).length > 0 ? (
              Object.values(groupedComments).map((comment: any) => (
                <Comment 
                  key={comment.id} 
                  comment={comment}
                  userAuthenticated={userAuthenticated}
                />
              ))
            ) : (
              <div className="text-center py-8">
                <MessageCircle className="h-12 w-12 mx-auto text-muted-foreground opacity-20 mb-2" />
                <p className="text-muted-foreground">Seja o primeiro a comentar</p>
              </div>
            )}
          </ChatMessageList>
        </div>

        <ReplyDialog pinId={pinId} />
      </div>
    </CommentsProvider>
  );
}
